var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.2,
    height: 14,
    viewBox: "0 0 11.2 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-brief",
    className: "cls-1",
    d: "M9.575,4A1.577,1.577,0,0,0,8,5.575v10.85A1.577,1.577,0,0,0,9.575,18h8.05A1.577,1.577,0,0,0,19.2,16.425V9.075a.523.523,0,0,0-.154-.371L14.5,4.154A.523.523,0,0,0,14.125,4Zm0,1.05H13.6V8.025A1.577,1.577,0,0,0,15.175,9.6H18.15v6.825a.526.526,0,0,1-.525.525H9.575a.524.524,0,0,1-.525-.525V5.575A.524.524,0,0,1,9.575,5.05Zm5.075.742L17.408,8.55H15.175a.524.524,0,0,1-.525-.525ZM10.975,11a.875.875,0,1,0,.875.875A.875.875,0,0,0,10.975,11Zm2.45.35a.525.525,0,1,0,0,1.05h3.15a.525.525,0,1,0,0-1.05Zm-2.45,2.45a.875.875,0,1,0,.875.875A.875.875,0,0,0,10.975,13.8Zm2.45.35a.525.525,0,1,0,0,1.05h3.15a.525.525,0,1,0,0-1.05Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructions);
export default __webpack_public_path__ + "static/media/Instructions.fca28882bfec762ec77ec8abbe5f5670.svg";
export { ForwardRef as ReactComponent };